import React, { useState } from "react";
export const LOPDashboardContext = React.createContext<any>(null);
export const LOPDashboardContextProvider = (props: any) => {
  const [LOPDashboard, setLOPDashboard] = useState<any>({});
  const value = {
    LOPDashboard,
    setLOPDashboard,
  };
  return (
    <LOPDashboardContext.Provider value={value}>
      {props.children}
    </LOPDashboardContext.Provider>
  );
};
export const MyBranchContext = React.createContext<any>(null);
export const MyBranchContextProvider = (props: any) => {
  const [myBranch, setMyBranch] = useState<any>({});
  const value = {
    myBranch,
    setMyBranch,
  };
  return (
    <MyBranchContext.Provider value={value}>
      {props.children}
    </MyBranchContext.Provider>
  );
};
